// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"ShopdmCredit_mainContent__1KlHI"};